<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" @submit.native.prevent style="margin-left:-0.5rem">
                                <el-form-item label="物料编码/描述" style="width: 55%;">
                                    <el-input clearable v-model="q.wlcodename"></el-input>
                                </el-form-item>
                                <el-form-item label="产品大类">
                                    <brselect category="product_level" v-model="q.cpdlcode" :v="q.cpdlcode" :clearable="true" />
                                </el-form-item>
                                <el-form-item class="h-formBtnOut" style="margin-top:-11px;width:100%;text-align: right;">
                                    <el-button class="w-tongyi" type="primary" v-if="this.dingdLeix == '1,5'"  @click="downExcel">导出EXCEL</el-button>
                                    <el-button class="w-tongyi" type="primary"  @click="handleFilter">搜索</el-button>
                                    <el-button class="w-tongyi" type="primary"  @click="choseSelected">选择</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
								:border="true"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="matecode"
                                    label="物料号"
                                    width="140"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="matedes"
                                    label="物料描述"
                                    width="220"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="oemDesc"
                                    label="规格型号"
                                    width="160"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="sykc"
                                    label="剩余库存"
                                    width="90"
                                    :key="Math.random()"
                                    v-if="this.dingdLeix == '1,5'"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="cpdlname"
                                    label="产品大类名称"
                                    width="120"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="dwcode"
                                    label="单位编码"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="dwname"
                                    label="单位名称"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    v-if="dailishangFlag"
                                    prop="jizhj"
                                    label="基准价"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    v-if="this.dingdLeix == '1,7'"
                                    :key="Math.random()"
                                    prop="expoPrice"
                                    label="展会价"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="djyxq"
                                    label="有效期"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>

                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="querypage"/>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';
    export default {
        name: "alluser",
        data(){
          return {
              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  wlcodename:null,
                  usercode:null,
                  ddlx:null,
                  fwddlx:null,
                  xmcode:null,
                  currencyCode:null,
                  customerChannelCode:null,
                  areaCode:null,
                  cpdlcode:null,
                  country:null,
              },
              ttdata:null,
              lists:[],

              dailishangFlag: true,
              userRole: '',
          }
        },
        methods: {
            handleFilter(){
                this.querypage();
            },
            querypage(p){

                  ss.wuliaoselect.selectUsaPage(this.q).then(rd=>{
                      this.q.total = rd.total;
                      this.ttdata = rd.records;

                      // this.userRole = this._user.roles;
                      // this.userRole.forEach((item, index) => {
                      //     if (item.id == "swyl_dailishang") {
                      //         this.dailishangFlag = false;
                      //     }
                      // })
                  })

            },
            handleSelectionChange(lists){
                if(this.oneflag){
                    this.$emit('choseObj', lists[0])
                }else{
                    this.lists = lists;
                }
            },
            choseSelected(){
                console.log("chchchchchch",this.lists)
                this.$emit('choseObj', this.lists)
            },
            downExcel(){
                updownfile.down("/api/select/wuliao/downloadExcel", this.q, "post");
            },
        },
        created(){
            if(this.UserCode){
                this.q.usercode = this.UserCode
                //订单类型
                this.q.ddlx = this.dingdLeix
                this.q.fwddlx = this.dingdLeixFw
                this.q.serviceProductsType = this.chanpLx
                //项目编号
                this.q.xmcode = this.xmcode
                this.q.country = this.country
                this.q.currencyCode = this.currencyCode
                this.q.customerChannelCode = this.customerChannelCode
                this.q.areaCode = this.areaCode
                this.querypage()
                //不是内部用户，都隐藏单价
                if(this._user.usertype!='0'){
                    this.dailishangFlag = false;
                }
            }
        },
        computed: {
            UserCode:function () {
                return this.usercode;
            },
            //订单类型
            dingdLeix:function () {
                return this.ddlx
            },
            //订单类型
            dingdLeixFw:function () {
                return this.fwddlx
            },
            //服务产品类型
            chanpLx:function () {
                return this.serviceProductsType
            },
            //项目编码
            XmCode:function () {
                return this.xmcode
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            usercode:{
                type:String,
            },
            //订单类型
            ddlx:{
                type:String,
            },
            //服务订单类型
            fwddlx:{
                type:String,
            },
            //服务产品类型
            serviceProductsType:{
                type:String,
            },
            oneflag:{
                type:Boolean,
            },
            xmcode:{
                type:String,
            },
            currencyCode:{
                type:String,
            },
            customerChannelCode:{
                type:String,
            },
            areaCode:{
              type:String,
            },
            country:{
                type:String,
            }
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
	.w-tongyi {
		padding: 0.1rem 0.25rem;
	}
</style>
